import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M22 9.2c0 3.956-3.219 7.179-7.18 7.179-3.972 0-7.203-3.219-7.203-7.18C7.617 5.23 10.847 2 14.82 2 18.781 2 22 5.23 22 9.2M2 21.18h3.516V2H2z"
    }, null, -1)
  ]))]))
}
export default { render: render }